/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import _ from 'lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Checkbox from '@material-ui/core/Checkbox';

import AssetThumbnail from './AssetThumbnail';
import CollectionAssetPosition from './CollectionAssetPosition';

const AssetsList = ({
  assets,
  assetsLength,
  handleChangePosition,
  handleDeleteAsset,
  onSelectAllClick,
  onSelectItem,
  isSelected,
  numSelected,
  customAction,
}) => {
  const isIndeterminate = numSelected > 0 && numSelected < assetsLength;
  const isAllSelected = numSelected > 0 && numSelected === assetsLength;

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell component="th">
            <Checkbox
              color="primary"
              style={{ padding: 0 }}
              onChange={onSelectAllClick}
              indeterminate={isIndeterminate}
              checked={isAllSelected}
            />
          </TableCell>
          <TableCell component="th">Thumbnail</TableCell>
          <TableCell component="th">Title</TableCell>
          <TableCell component="th">Status</TableCell>
          <TableCell component="th" numeric>
            Position
          </TableCell>
          {customAction && <TableCell component="th" width={20} />}
          <TableCell component="th" width={20} />
        </TableRow>
      </TableHead>
      <TableBody>
        {_.map(assets, (a) => {
          return (
            <TableRow key={a.id}>
              <TableCell padding="checkbox">
                <Checkbox
                  color="primary"
                  checked={isSelected(a.id)}
                  onChange={() => onSelectItem(a.id)}
                />
              </TableCell>
              <TableCell scope="row">
                <AssetThumbnail
                  source="thumbnail.url"
                  record={a}
                  title="title"
                />
              </TableCell>
              <TableCell scope="row">{a.title}</TableCell>
              <TableCell scope="row">{a.status}</TableCell>
              <TableCell scope="row" numeric>
                <CollectionAssetPosition
                  key={_.uniqueId()}
                  value={a.index}
                  max={assetsLength}
                  onChange={(value) => {
                    handleChangePosition(a.id, value);
                  }}
                />
              </TableCell>
              <TableCell>
                <IconButton
                  aria-label="Delete"
                  onClick={() => {
                    handleDeleteAsset(a.id);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default AssetsList;
